import { defineMessages, Messages } from 'react-intl';

export const LocalizedCityNamesById: Messages = defineMessages({
  28899: { id: 'city.28899', defaultMessage: 'Jambi City' },
  35124: { id: 'city.35124', defaultMessage: 'South Tangerang' },
  116448: { id: 'city.116448', defaultMessage: 'Taoyuan' },
  116450: { id: 'city.116450', defaultMessage: 'Taipei' },
  116452: { id: 'city.116452', defaultMessage: 'Xinying' },
  116453: { id: 'city.116453', defaultMessage: 'Tainan' },
  116454: { id: 'city.116454', defaultMessage: 'Fengyuan' },
  116455: { id: 'city.116455', defaultMessage: 'Taichung' },
  116456: { id: 'city.116456', defaultMessage: 'Daxi' },
  116457: { id: 'city.116457', defaultMessage: 'Banqiao' },
  116458: { id: 'city.116458', defaultMessage: 'Puli' },
  116460: { id: 'city.116460', defaultMessage: 'Pingtung' },
  116461: { id: 'city.116461', defaultMessage: 'Nantou' },
  116462: { id: 'city.116462', defaultMessage: 'Miaoli' },
  116465: { id: 'city.116465', defaultMessage: 'Fengshan' },
  116466: { id: 'city.116466', defaultMessage: 'Kaohsiung' },
  116467: { id: 'city.116467', defaultMessage: 'Yilan' },
  116468: { id: 'city.116468', defaultMessage: 'Hualien City' },
  116469: { id: 'city.116469', defaultMessage: 'Hsinchu' },
  116471: { id: 'city.116471', defaultMessage: 'Zhubei' },
  116473: { id: 'city.116473', defaultMessage: 'Keelung' },
  116474: { id: 'city.116474', defaultMessage: 'Jiayi Shi' },
  116475: { id: 'city.116475', defaultMessage: 'Chang-hua' },
  116476: { id: 'city.116476', defaultMessage: 'Taoyuan City' },
  116477: { id: 'city.116477', defaultMessage: 'Taitung City' },
  116478: { id: 'city.116478', defaultMessage: 'Nangan' },
  132241: { id: 'city.132241', defaultMessage: 'Vung Tau' },
  132250: { id: 'city.132250', defaultMessage: 'Vinh Long' },
  132254: { id: 'city.132254', defaultMessage: 'Vinh' },
  132269: { id: 'city.132269', defaultMessage: 'Tra Vinh' },
  132282: { id: 'city.132282', defaultMessage: 'Thu Duc' },
  132283: { id: 'city.132283', defaultMessage: 'Thu Dau Mot' },
  132288: { id: 'city.132288', defaultMessage: 'Ai Tu' },
  132294: { id: 'city.132294', defaultMessage: 'Ho Chi Minh City' },
  132296: { id: 'city.132296', defaultMessage: 'Thanh Hoa' },
  132303: { id: 'city.132303', defaultMessage: 'Tay Ninh' },
  132304: { id: 'city.132304', defaultMessage: 'Tay Ho' },
  132311: { id: 'city.132311', defaultMessage: 'Tan An' },
  132320: { id: 'city.132320', defaultMessage: 'Son La' },
  132323: { id: 'city.132323', defaultMessage: 'Soc Trang' },
  132345: { id: 'city.132345', defaultMessage: 'Phu Yen' },
  132349: { id: 'city.132349', defaultMessage: 'Phu Tho' },
  132358: { id: 'city.132358', defaultMessage: 'Phuc Yen' },
  132377: { id: 'city.132377', defaultMessage: 'Nha Trang' },
  132378: { id: 'city.132378', defaultMessage: 'Nha Be' },
  132383: { id: 'city.132383', defaultMessage: 'Tien Hai' },
  132395: { id: 'city.132395', defaultMessage: 'My Tho' },
  132411: { id: 'city.132411', defaultMessage: 'Long Xuyen' },
  132412: { id: 'city.132412', defaultMessage: 'Long Thanh' },
  132422: { id: 'city.132422', defaultMessage: 'Lao Cai' },
  132431: { id: 'city.132431', defaultMessage: 'Dak Lak' },
  132447: { id: 'city.132447', defaultMessage: 'Hung Yen' },
  132448: { id: 'city.132448', defaultMessage: 'Hue' },
  132450: { id: 'city.132450', defaultMessage: 'Binh Long' },
  132453: { id: 'city.132453', defaultMessage: 'Hoi An' },
  132454: { id: 'city.132454', defaultMessage: 'Hoc Mon' },
  132462: { id: 'city.132462', defaultMessage: 'Ha Noi City' },
  132465: { id: 'city.132465', defaultMessage: 'Hai Phong' },
  132470: { id: 'city.132470', defaultMessage: 'Ha Dong' },
  132494: { id: 'city.132494', defaultMessage: 'Dien Bien Phu' },
  132497: { id: 'city.132497', defaultMessage: 'Di An' },
  132500: { id: 'city.132500', defaultMessage: 'Da Nang City' },
  132501: { id: 'city.132501', defaultMessage: 'Ða Lat' },
  132502: { id: 'city.132502', defaultMessage: 'Dak Song' },
  132526: { id: 'city.132526', defaultMessage: 'Cao Lanh' },
  132528: { id: 'city.132528', defaultMessage: 'Can Tho' },
  132534: { id: 'city.132534', defaultMessage: 'Cam Ranh' },
  132538: { id: 'city.132538', defaultMessage: 'Ca Mau' },
  132544: { id: 'city.132544', defaultMessage: 'Buon Ma Thuot' },
  132554: { id: 'city.132554', defaultMessage: 'Bien Hoa' },
  132555: { id: 'city.132555', defaultMessage: 'Ben Tre' },
  132556: { id: 'city.132556', defaultMessage: 'Ben Cau' },
  132562: { id: 'city.132562', defaultMessage: 'Ban Yen Nhan' },
  132567: { id: 'city.132567', defaultMessage: 'Bac Ninh' },
  132569: { id: 'city.132569', defaultMessage: 'Bac Ha' },
  132570: { id: 'city.132570', defaultMessage: 'Bac Giang' },
  132574: { id: 'city.132574', defaultMessage: 'An Hoa' },
  132575: { id: 'city.132575', defaultMessage: 'An Nhon' },
  132578: { id: 'city.132578', defaultMessage: 'An Chau' },
  132581: { id: 'city.132581', defaultMessage: 'District 7' },
  132641: { id: 'city.132641', defaultMessage: 'An Phu' },
  132644: { id: 'city.132644', defaultMessage: 'Bat Xat' },
  132670: { id: 'city.132670', defaultMessage: 'Lam Dong' },
  132681: { id: 'city.132681', defaultMessage: 'Ba Ria City' },
  132722: { id: 'city.132722', defaultMessage: 'Cau Giay' },
  132723: { id: 'city.132723', defaultMessage: 'Thanh Xuan' },
  132724: { id: 'city.132724', defaultMessage: 'Dong Da' },
  132725: { id: 'city.132725', defaultMessage: 'Hoan Kiem' },
  132726: { id: 'city.132726', defaultMessage: 'Hai BaTrung' },
  132734: { id: 'city.132734', defaultMessage: 'Thanh Khe' },
  132776: { id: 'city.132776', defaultMessage: 'Dong Nai' },
  132778: { id: 'city.132778', defaultMessage: 'Bac Ai' },
  132786: { id: 'city.132786', defaultMessage: 'Tan Phu' },
  132815: { id: 'city.132815', defaultMessage: 'District 2' },
  132820: { id: 'city.132820', defaultMessage: 'Quan Mot' },
  132821: { id: 'city.132821', defaultMessage: 'Phu Nhuan District' },
  132822: { id: 'city.132822', defaultMessage: 'Tan Phu District' },
  132826: { id: 'city.132826', defaultMessage: 'Binh Thanh District' },
});
